/**
 * La aplicacion y el rol de nomina en identidad. Viven aqui y no en un servicio para que
 * `app.config.ts` (`proveerSesion({ aplicacion })`) y `PermisosService` los compartan.
 *
 * Hasta el 2026-10-23 este archivo tambien declaraba `ROLES` (`ADMINISTRADOR`, `CONSULTA`,
 * `GLOBAL`), los roles que la fachada `@auth` derivaba del acceso; `PermisosService` lee
 * ahora el acceso activo directo y la constante se retiro.
 */
/**
 * Codigo de la aplicacion de nomina en identidad (`aplicacionCodigo` del acceso
 * activo; `aplicacionId` 10, antes el sistema 68 de `dbusers.catsistema`).
 */
export const APLICACION_NOMINA = 'nomina';

/** Rol «Administrador Nomina» (`administrador-nomina`; el mismo id 203 del SSO anterior). */
export const ROL_ADMINISTRADOR_NOMINA = 203;
